// Builds the `switchMemberFromDivisions` payload for the provider division-switch flow.
// Players who no longer hold an active registration in `fromDivisionId` (already switched
// away or withdrawn) are dropped — submitting them 400s /v2/tms/events/{id}/divisions/switch
// (HUB-1911, producer of the HUB-1909 500). Doubles partners that are both being moved are
// paired into a single entry and de-duplicated.
export const buildSwitchMemberFromDivisions = (playersToMove, memberIds, fromDivisionId) => {
    const seen = new Set();
    const switchMemberFromDivisions = [];

    (playersToMove || []).forEach((player) => {
        if (seen.has(player.memberId)) {
            return;
        }

        const playerDivision = player.divisions?.find(d => d.id === fromDivisionId);
        if (!playerDivision) {
            return;
        }

        const partnerId = playerDivision.partners?.[0];
        if (partnerId && memberIds.includes(partnerId) && !seen.has(partnerId)) {
            switchMemberFromDivisions.push({ fromDivisionId, memberId1: player.memberId, memberId2: partnerId });
            seen.add(player.memberId);
            seen.add(partnerId);
        } else {
            switchMemberFromDivisions.push({ fromDivisionId, memberId1: player.memberId });
            seen.add(player.memberId);
        }
    });

    return switchMemberFromDivisions;
};
